const exampleTradingBot = `from gql import Client, gql
from gql.transport.requests import RequestsHTTPTransport
import datetime
from requests import post, get, delete, put
import json

class NUSwapConnector():
    def __init__(self, token):
        self.token = "Bearer " + token 
        self.transport = RequestsHTTPTransport(
                            url="http://localhost:4000/graphql",
                            headers={'Authorization': self.token},
                            verify=True,
                            retries=3,
                        )
        self.client = Client(transport=self.transport, fetch_schema_from_transport=True)
        self.userid = self.getUserDetails()['userid']
        self.walletid = self.getUserDetails()['userid']

# ====================================================================================================
    # Main User Queries
    # Get Details
    def getUserDetails(self):
        query = gql(
                        """
                        query CurrentUser {
                            currentUser {
                                userid
                                name
                                alias
                                email
                                phone
                                balance
                            }
                        }
                    """
        )

        result = self.client.execute(query)
        return result['currentUser']   
    
    # Get Balance
    def getUserBalance(self):
        query = gql(
                        """
                        query CurrentUser {
                            currentUser {
                                balance
                            }
                        }
                    """
        )

        result = self.client.execute(query)
        return result['currentUser']['balance']
    
    # Get Wallet Assets
    def getAssets(self):
        query = gql(
                        """
                        query GetWalletAssetsWalletID($walletid: ID!) {
                            getWalletAssetsWalletID(walletid: $walletid) {
                                symbol
                                amount
                            }
                        }
                    """
        )

        variables_dict = {
            'walletid': self.walletid
        }
        result = self.client.execute(query, variable_values = variables_dict)
        
        return result['getWalletAssetsWalletID']
# ====================================================================================================   
    # Order Queries
    # Get Open Ask
    def getOpenAsk(self, symbol):
        query = gql(
                        """
                        query GetOpenAskOrdersForSymbolAndUser($symbol: String!, $owner: ID) {
                            getOpenAskOrdersForSymbolAndUser(symbol: $symbol, owner: $owner) {
                                orderid
                                quantity
                                price
                                openquantity
                                fillcost
                                createdat
                                updatedat
                            }
                        }
                    """
        )

        variables_dict = {
            'symbol': symbol,
            'owner': self.userid
        }
        result = self.client.execute(query, variable_values = variables_dict)['getOpenAskOrdersForSymbolAndUser']
        
        if result is not None:
            for i in result:
                i['createdat'] = datetime.datetime.fromtimestamp(int(i['createdat']) / 1e3).isoformat("T")
                i['updatedat'] = datetime.datetime.fromtimestamp(int(i['updatedat']) / 1e3).isoformat("T")
        
        return result
    
    # Get Open Bid
    def getOpenBid(self, symbol):
        query = gql(
                        """
                        query GetOpenBidOrdersForSymbolAndUser($symbol: String!, $owner: ID) {
                            getOpenBidOrdersForSymbolAndUser(symbol: $symbol, owner: $owner) {
                                orderid
                                quantity
                                price
                                openquantity
                                fillcost
                                createdat
                                updatedat
                            }
                        }
                    """
        )

        variables_dict = {
            'symbol': symbol,
            'owner': self.userid
        }
        result = self.client.execute(query, variable_values = variables_dict)['getOpenBidOrdersForSymbolAndUser']
        
        if result is not None:
            for i in result:
                i['createdat'] = datetime.datetime.fromtimestamp(int(i['createdat']) / 1e3).isoformat("T")
                i['updatedat'] = datetime.datetime.fromtimestamp(int(i['updatedat']) / 1e3).isoformat("T")
            
        return result
    
    # Get Closed
    def getClosed(self, symbol):
        query = gql(
                        """
                        query GetClosedOrdersForSymbolAndUser($symbol: String!, $owner: ID) {
                            getClosedOrdersForSymbolAndUser(symbol: $symbol, owner: $owner) {
                                orderid
                                buyside
                                quantity
                                price
                                fillprice
                                createdat
                                filledat
                            }
                        }
                    """
        )

        variables_dict = {
            'symbol': symbol,
            'owner': self.userid
        }
        result = self.client.execute(query, variable_values = variables_dict)['getClosedOrdersForSymbolAndUser']

        if result is not None:
            for i in result:
                i['createdat'] = datetime.datetime.fromtimestamp(int(i['createdat']) / 1e3).isoformat("T")
                i['filledat'] = datetime.datetime.fromtimestamp(int(i['filledat']) / 1e3).isoformat("T")
            
        return result
    
    # Get All Open
    def getAllOpen(self, symbol):
        openAsks = self.getOpenAsk(symbol)
        openBids = self.getOpenBid(symbol)
        
        result = []
    
        if openAsks is not None:
            for i in openAsks:
                i['buyside'] = 'SELL'
                result.append(i)
                
        if openBids is not None:
            for i in openBids:
                i['buyside'] = 'BUY'
                result.append(i)
            
        return result
    
    # Get All Orders
    def getAllOrders(self, symbol):
        openOrders = self.getAllOpen(symbol)
        closedOrders = self.getClosed(symbol)
        
        result = []
        
        if openOrders is not None:
            for i in openOrders:
                i['status'] = 'OPEN'
                if i['fillcost'] == 0:
                    i['fillprice'] = 0
                else:
                    i['fillprice'] = float(i['fillcost']) / ( float(i['quantity']) - float(i['openquantity']) )
                i['filledat'] = None
                result.append(i)
                
        if closedOrders is not None:
            for i in closedOrders:
                i['status'] = 'CLOSED'
                i['fillcost'] = float(i['fillprice']) * float(i['quantity'])
                i['openquantity'] = 0
                i['updatedat'] = i['filledat']
                result.append(i)
            
        return result
# ====================================================================================================
    # Operations
    # Limit Buy
    # Limit Sell
    # Market Buy
    # Market Sell
    def placeOrder(self, symbol, order_type, side, quantity, price = 0):
        ownerId = self.userid
        walletId = self.walletid
        
        if order_type not in ['Limit','Market']:
            print("ORDER TYPE ERROR. Must be in ",['Limit','Market'])
            return
        if side not in ['Buy','Sell']:
            print("ORDER TYPE ERROR. Must be in ",['Buy','Sell'])
            return
        if quantity <= 0:
            print("quantity must be greater than 0")
            return
        result = post("http://localhost:8000/order",json={
            'symbol':symbol, 
            'type': order_type,
            'side': side,
            'quantity': quantity,
            'price': price,
            'owner_id': ownerId,
            'wallet_id': walletId
        })
        return result
    
token = "Your API KEY"
NSC = NUSwapConnector(token)

# Place an order
symbol = "ETHUSD"
response = NSC.placeOrder(symbol,'Limit', 'Buy', 0.01, 3000)

# Print the response
print(response.text)`

export default exampleTradingBot
